const isEmptyValue = (value: unknown): boolean =>
  value === undefined || value === null || value === '';

const isObjectLike = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null;

// Array elements are cleaned but never dropped: the API pairs array entries
// positionally with their documents, so removing an entry would reindex the
// rest of the payload onto the wrong records.
const pruneValue = (value: unknown): unknown => {
  if (Array.isArray(value)) return value.map(pruneValue);
  if (!isObjectLike(value)) return value;

  return Object.keys(value).reduce<Record<string, unknown>>((acc, key) => {
    const nested = value[key];
    if (Array.isArray(nested) || isObjectLike(nested)) {
      acc[key] = pruneValue(nested);
    } else if (!isEmptyValue(nested)) {
      acc[key] = nested;
    }
    return acc;
  }, {});
};

export const removeEmptyValues = (
  obj: Record<string, unknown>,
): Record<string, unknown> => pruneValue(obj) as Record<string, unknown>;
